module.exports = __webpack_public_path__ + "img/sj-three.72d15dc4.png";